import { BtnClose } from '../Button';
import ButtonMoreView from '../ButtonMoreView';
import { PopCcontainer, PopupTitle } from '../Css/Pop';
import Modal from '../Modal';
import { Tit } from '../Titles';
import Image from '@/components/Image';
import LinkSafe from '@/components/LinkSafe';
import { breakpoint } from '@/helpers/BreakpointHelper';
import React, { FC } from 'react';
import styled from 'styled-components';

export interface ModalProps {
  isOpen?: boolean;
  // 모달 바깥쪽 누를시 닫을수 있는지 여부
  dismissable?: boolean;
  // 닫힘요청시 콜백
  onRequestClose: () => void;
  maxWidth?: string;
}

interface KoreaCooperationLayerProps extends ModalProps {
  PopSid: string | number;
  PopTitle: string;
  PopImg: string;
  PopupImgYn: string;
  PopContents: string;
  link: string;
  video: string;
  popInnerTit: string;
}

const PopContent = styled.div`
  padding: 32px 0;

  ${Tit} {
    margin-top: 32px;
    line-height: 1.6;
  }
  .dec {
    margin-top: 16px;
    line-height: 1.7;
  }
  .btn-wrap {
    text-align: right;
    margin-top: 64px;

    ${ButtonMoreView} {
      text-align: left;
      width: 100%;
      max-width: 352px;
    }
  }

  ${breakpoint(`mobile`)} {
    padding: 22px 0 24px 0;
    ${Tit} {
      margin-top: 19px;
    }
    .dec {
      margin-top: 8px;
      line-height: 2;
    }
    .btn-wrap {
      margin-top: 48px;

      ${ButtonMoreView} {
        max-width: 100%;
      }
    }
  }
`;

const VideoContainer = styled.div`
  width: 100%;
  position: relative;

  &::before {
    content: '';
    display: block;
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 0);
    background-size: auto 100%;
    width: 1920px;
    height: 710px;

    ${breakpoint(1160)} {
      height: 61.21vw;
    }
  }

  .video-wrap {
    width: 100%;
    max-width: 1120px;
    margin: 0 auto;
    /* padding-top: 66.69%; */
    padding-top: 56.25%;
    position: relative;
  }
  .video {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
`;

const KoreaCooperationLayerPopup: FC<KoreaCooperationLayerProps> = ({
  onRequestClose,
  ...props
}) => (
  <Modal onRequestClose={onRequestClose} maxWidth="640px" {...props}>
    <PopCcontainer>
      <PopupTitle>
        <h2>
          <Tit
            size="s3"
            color="sky"
            dangerouslySetInnerHTML={{ __html: props.popInnerTit }}
          />
        </h2>
        <BtnClose onClick={() => onRequestClose()}>
          <span className="a11y">닫기</span>
        </BtnClose>
      </PopupTitle>
      {props.PopSid === 1 ? (
        <PopContent>
          {props.PopupImgYn === null || props.PopupImgYn === `` ? (
            ``
          ) : (
            <Image pcSrc={props.PopImg} mobileSrc={props.PopImg} />
          )}

          <Tit
            size="s4-1"
            color="sky"
            dangerouslySetInnerHTML={{ __html: props.PopTitle }}
          />
          <p
            className="dec"
            dangerouslySetInnerHTML={{ __html: props.PopContents }}
          />
        </PopContent>
      ) : (
        ``
      )}
      {props.PopSid === 2 ? (
        <PopContent>
          <Image pcSrc={props.PopImg} mobileSrc={props.PopImg} />
          <Tit
            size="s4-1"
            color="sky"
            dangerouslySetInnerHTML={{ __html: props.PopTitle }}
          />

          {!!props.PopContents && (
            <p
              className="dec"
              dangerouslySetInnerHTML={{ __html: props.PopContents }}
            />
          )}
          <div className="btn-wrap">
            {props.video ? (
              <LinkSafe target="_blank" to={props.video} className="link-item">
                <ButtonMoreView mode="sky">자세히 보기</ButtonMoreView>
              </LinkSafe>
            ) : (
              <>
                {props.link !== null && props.link !== `` ? (
                  <LinkSafe to={props.link} className="link-item">
                    <ButtonMoreView mode="sky">소식 자세히 보기</ButtonMoreView>
                  </LinkSafe>
                ) : (
                  ``
                )}
              </>
            )}
          </div>
        </PopContent>
      ) : (
        ``
      )}
      {props.PopSid === 3 ? (
        <PopContent>
          <Image pcSrc={props.PopImg} mobileSrc={props.PopImg} />
          <Tit
            size="s4-1"
            color="sky"
            dangerouslySetInnerHTML={{ __html: props.PopTitle }}
          />

          {!!props.PopContents && (
            <p
              className="dec"
              dangerouslySetInnerHTML={{ __html: props.PopContents }}
            />
          )}
          <div className="btn-wrap">
            {props.video ? (
              <LinkSafe target="_blank" to={props.video} className="link-item">
                <ButtonMoreView mode="sky">자세히 보기</ButtonMoreView>
              </LinkSafe>
            ) : (
              <>
                {props.link !== null && props.link !== `` ? (
                  <LinkSafe to={props.link} className="link-item">
                    <ButtonMoreView mode="sky">소식 자세히 보기</ButtonMoreView>
                  </LinkSafe>
                ) : (
                  ``
                )}
              </>
            )}
          </div>
        </PopContent>
      ) : (
        ``
      )}
    </PopCcontainer>
  </Modal>
);

export default KoreaCooperationLayerPopup;
